/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Agree_PrefixInputs */

const en_common_sign_agree_prefix = /** @type {(inputs: Common_Sign_Agree_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By signing up, you agree to our`)
};

/**
* | output |
* | --- |
* | "By signing up, you agree to our" |
*
* @param {Common_Sign_Agree_PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_agree_prefix = /** @type {((inputs?: Common_Sign_Agree_PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Agree_PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_agree_prefix(inputs)
});
export { common_sign_agree_prefix as "common.sign.agree_prefix" }